(() => {
  const openSeason = hash => {
    let id;
    try { id = decodeURIComponent(hash.slice(1)); } catch { return; }
    const season = document.getElementById(id);
    if (!season?.matches('details.rmc-season')) return;
    season.open = true;
    season.scrollIntoView({block: 'start'});
  };
  document.querySelectorAll('.rmc-season-nav a').forEach(link => {
    link.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (!document.getElementById(link.hash.slice(1))?.matches('details.rmc-season')) return;
      event.preventDefault();
      if (location.hash !== link.hash) history.pushState(null, '', link.hash);
      openSeason(link.hash);
    });
  });
  window.addEventListener('hashchange', () => openSeason(location.hash));
  if (location.hash) openSeason(location.hash);
})();
